export default function Plane(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="36"
			height="36"
			viewBox="0 0 36 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M27.7633 30.4812L24.6832 16.4492L30.6725 10.4601C33.2392 7.89327 34.0948 4.47079 33.2393 2.75955C31.528 1.904 28.1055 2.75955 25.5387 5.32634L19.5496 11.3156L5.51762 8.23549C4.66207 8.06438 3.97748 8.4066 3.63527 9.09104L3.12194 9.94673C2.77972 10.8023 2.95083 11.6578 3.63527 12.1713L12.7047 18.1604L9.28232 23.2941H4.14874L2.4375 25.0052L7.57108 28.4277L10.9936 33.5613L12.7047 31.8501V26.7165L17.8384 23.2941L23.8275 32.3635C24.341 33.048 25.1965 33.2191 26.0521 32.8769L26.9078 32.5346C27.5922 32.0212 27.9344 31.3367 27.7633 30.4812Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
